"use client";

import { scrollToTop } from "@homeinstead/shared";
import {
  AnimatePresence,
  domAnimation,
  LazyMotion,
  motion,
} from "motion/react";
import { Button } from "~care/components/ui/Button/Button";

export function NavigationBottomPanel({
  showBottomPanel,
}: {
  showBottomPanel: boolean;
}) {
  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        {showBottomPanel && (
          <motion.section
            animate={{ opacity: 1, y: 0 }}
            aria-live="polite"
            className="fixed bottom-0 z-[100] flex w-full items-center justify-center bg-support-tints-400 p-4 px-14 md:hidden"
            exit={{ opacity: 0, y: 100 }}
            initial={{ opacity: 0, y: 100 }}
          >
            <Button
              className="px-4 md:hidden"
              onClick={scrollToTop}
              variant="primary"
            >
              Request a Care Consultation
            </Button>
          </motion.section>
        )}
      </AnimatePresence>
    </LazyMotion>
  );
}
